import React from 'react';
import Button from '@material-ui/core/Button';
import { Progress, ErrorPage, ErrorPanel } from '@backstage/core-components';
import { BrowserRouter, useInRouterContext, MemoryRouter } from 'react-router-dom';

function OptionallyWrapInRouter({ children }) {
  if (useInRouterContext()) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(MemoryRouter, null, children);
}
const DefaultNotFoundPage = () => /* @__PURE__ */ React.createElement(ErrorPage, { status: "404", statusMessage: "PAGE NOT FOUND" });
const DefaultBootErrorPage = ({ step, error }) => {
  let message = "";
  if (step === "load-config") {
    message = `The configuration failed to load, someone should have a look at this error: ${error.message}`;
  } else if (step === "load-chunk") {
    message = `Lazy loaded chunk failed to load, try to reload the page: ${error.message}`;
  }
  return /* @__PURE__ */ React.createElement(OptionallyWrapInRouter, null, /* @__PURE__ */ React.createElement(ErrorPage, { statusMessage: message, stack: error.stack }));
};
const DefaultErrorBoundaryFallback = ({
  error,
  resetError,
  plugin
}) => {
  return /* @__PURE__ */ React.createElement(
    ErrorPanel,
    {
      title: `Error in ${plugin == null ? void 0 : plugin.getId()}`,
      defaultExpanded: true,
      error
    },
    /* @__PURE__ */ React.createElement(Button, { variant: "outlined", onClick: resetError }, "Retry")
  );
};
const components = {
  Progress,
  Router: BrowserRouter,
  NotFoundErrorPage: DefaultNotFoundPage,
  BootErrorPage: DefaultBootErrorPage,
  ErrorBoundaryFallback: DefaultErrorBoundaryFallback
};

export { OptionallyWrapInRouter, components };
//# sourceMappingURL=components.esm.js.map
